// Local JWT expiry check. Signature is NOT verified here — the backend stays
// the only authority on whether a token is actually valid. This exists so the
// UI never renders a logged-in state around a token the server will certainly
// reject.

// Treat a token as expired this many seconds before its real `exp`, so a
// request in flight cannot race the expiry boundary.
const EXPIRY_SKEW_SECONDS = 30;

export function isJwtExpired(token: string | null | undefined): boolean {
  if (!token) {
    return true;
  }

  const segments = token.split('.');
  if (segments.length !== 3) {
    return true;
  }

  try {
    const base64 = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    // Not padEnd: this project's tsconfig `lib` stops at es2016.
    const remainder = base64.length % 4;
    const payload = JSON.parse(atob(base64 + (remainder === 0 ? '' : '='.repeat(4 - remainder))));

    if (typeof payload !== 'object' || payload === null || typeof payload.exp !== 'number') {
      return true;
    }

    // exp is in seconds, Date.now() is in milliseconds.
    return Date.now() >= (payload.exp - EXPIRY_SKEW_SECONDS) * 1000;
  } catch {
    return true;
  }
}
